<p-dialog header="Edit Case" *ngIf="isShow" [(visible)]="isShow">
  <div class="dialog-area" *ngIf="case">
    <div class="photo-area">
      <img class="w-full" [src]="currentCase.imageUrl" />
    </div>
    <div class="info-area">
      <div>
        <strong>ID:</strong> {{currentCase.id}}
      </div>
      <div>
        <strong>Name:</strong>
      </div>
      <div>
        <input pInputText type="text" [(ngModel)]="currentCase.name">
      </div>
      <div class="mt-3">
        <strong>E-mail:</strong>
      </div>
      <div>
        <input pInputText type="text" [(ngModel)]="currentCase.email">
      </div>
      <div class="mt-3">
        <strong>Phone:</strong>
      </div>
      <div>
        <input pInputText type="text" [(ngModel)]="currentCase.phone">
      </div>
      <div class="mt-3">
        <strong>Gender:</strong>
      </div>
      <div>
        <p-radioButton name="gender" value="1" [(ngModel)]="currentCase.gender" inputId="gender1" />
        <label for="gender1" class="ml-2">
          Male
        </label>
        <p-radioButton name="gender" value="2" [(ngModel)]="currentCase.gender" inputId="gender2" />
        <label for="gender2" class="ml-2">
          Female
        </label>
      </div>
      <div class="mt-3">
        <strong>Symptom:</strong>
      </div>
      <div>
        <input pInputText type="text" [(ngModel)]="currentCase.symptom">
      </div>
      <div class="action-area">
        <div>
          <button class="w-full" pButton label="Save" (click)="onSave()"></button>
        </div>
        <div>
          <button class="w-full" pButton severity="secondary" label="Cancel" (click)="onCancel()"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
